<div
  v-if="shouldRenderConfig"
  v-show="alwaysShow || getShowUpload"
  v-bind:class="[getClassName, statusUploaded ? getClassName + 'Uploaded' : '', isLoading ? getClassName + 'IsLoading' : '']"
>
  <vue-dropzone
    :ref="refId"
    :id="refId"
    :options="dropzoneOptions"
    v-show="!statusUploaded"
    @vdropzone-complete="afterComplete"
    @vdropzone-sending="sendFile"
    @vdropzone-file-added="fileAdded"
    @vdropzone-drop="drop"
    @vdropzone-error="error"
    @vdropzone-mounted="mounted"
    @vdropzone-upload-progress="progress"
  >
  </vue-dropzone>
  <div v-bind:class="getClassName + 'LoadingContainer'" v-show="isLoading">
    <ProgressBar :value="loadingProgress"  style="width:100%"></ProgressBar>
    <div v-bind:class="getClassName + 'LoadingValue'" >
      {{parseInt(loadingProgress) + " %"}}
    </div>
  </div>
  <div v-bind:class="getClassName + 'Preview'" v-if="statusUploaded">
    <div
      v-bind:class="getClassName + 'PreviewContainer'"
      v-if="getShowPreviewInUpload && previewFile"
    >
      <a
        @click="onPreview()"
        v-if="previewFile && showRearrange"
      >
        <img :ref="refId + 'Img'" :src="previewFile" />
      </a>
      <a
        :data-fancybox="'gallery' + refId"
        :href="previewFileLink"
        v-if="previewFile && !showRearrange"
      >
        <img :ref="refId + 'Img'" :src="previewFile" />
      </a>
    </div>
    <div v-bind:class="getClassName + 'StatusContainer'">
      <div
        v-if="showPreflight"
        v-bind:class="getClassName + 'PreflightContainer'"
      >
        <appPreflightInfo
          v-for="(item,index) in preflightData"
          v-bind:key="index"
          v-bind:propsData="item"
        >
        </appPreflightInfo>
      </div>
      <div
        v-if="showPitstopInfo || showPitstopLoading"
        v-bind:class="getClassName + 'PreflightContainer'"
      >
        <appPreflightInfo
          v-if="showPitstopInfo"
          v-for="(item,index) in showPitstopInfo"
          v-bind:key="index"
          v-bind:propsData="item"
        >
        </appPreflightInfo>
        <div v-if="showPitstopLoading">
          <appUploadLoading></appUploadLoading>
        </div>
      </div>
      <div v-bind:class="getClassName + 'ActionsContainer'">
        <button type="button" 
            class="btn btn-primary matrix_uploadButtonDelete"             
            v-if="showDeleteButton"
            @click="onDelete()">
          {{$t('Delete')}}
        </button>
        <button
          type="button"
          class="btn btn-primary matrix_uploadButtonPreview"
          @click="onPreview()"
          v-if="getShowPreviewInUpload && previewFile"
        >
          {{$t('Preview')}}
        </button>
        <button type="button" class="btn btn-primary matrix_uploadButtonDownload" @click="onDownload()">
          {{$t('Download')}}
        </button>
        <button
          v-if="showRearrange"
          type="button"
          class="btn btn-primary matrix_uploadButtonRearrange"
          @click="onRearrange()"
        >
          {{$t('Rearrange files')}}
        </button>
        <button
          v-if="pitstopReport"
          type="button"
          class="btn btn-primary matrix_uploadButtonViewReport"
          @click="onViewReport()"
        >
          {{$t('View report')}}
        </button>
      </div>
    </div>
  </div>
</div>
